import { createSlice } from '@reduxjs/toolkit'

export const bedInfosSlice = createSlice({
    name: 'bedInfos',
    initialState: {
        value: 0,
        data: {
            // 範例 : 
            // [resident_id]: {
            //     bed_id: 20
            //     secs: 0,
            //     secsAct: false,
            //     autoBtn: false,
            //     allLockBtn: false,
            // }
        },
        resident_id_data: {},
        bed_states: localStorage.getItem("bed_states") ? JSON.parse(localStorage.getItem("bed_states")) : localStorage.setItem("bed_states", `{}`),
        bed_states_all: localStorage.getItem("bed_states_all") ? JSON.parse(localStorage.getItem("bed_states_all")) : localStorage.setItem("bed_states_all", `{}`),

        /* 整合床設定資訊 (含久臥時間) */
        local_data: {},
    },
    reducers: {
        ADD_BTN_STATUS: (state, action) => {
            if (action.payload !== null) {
                if (state.data[action.payload.resident_id] === undefined) {
                    state.data = {
                        [action.payload.resident_id]: {
                            bed_id: action.payload.bed_id,
                            secs: 0,
                            secsAct: false,
                            autoBtn: action.payload.autoBtn,
                            allLockBtn: action.payload.allLockBtn,
                        }
                    }
                } else {
                    state.data[action.payload.resident_id].autoBtn = action.payload.autoBtn;
                    state.data[action.payload.resident_id].allLockBtn = action.payload.allLockBtn;
                }
            }
        },
        SET_DATA: (state, action) => {
            try {
                if (action.payload !== undefined && action.payload !== null) {
                    for (const [key, value] of Object.entries(action.payload)) state.data[key] = value;
                }
            } catch (e) { console.error(e); }
        },
        GET_RESIDENT_ID_DATA: (state, action) => {
             try {
                if (action.payload !== undefined && action.payload !== null) {
                    const key = String(action.payload);
                    if (state['data'] && state['data'][key]) {
                        state.resident_id_data = state['data'][key];
                    } else {
                        state.resident_id_data = {};
                    }
                }
            } catch (e) { console.error(e); }
        },
        ADD_RR: (state, action) => {
            try {
                if (action.payload && action.payload !== null) {

                    const key = Object.keys(action.payload)[0];
                    const value = Object.values(action.payload)[0];

                    state.rr[key] = value;
                    localStorage.setItem("rr", JSON.stringify(state.rr));
                }
            } catch (e) { console.error(e); }
        },
        /**
         * // ✎NOTE: ---------〖Redux - 新增bed_state訊息到 local session〗---------
         *
         * @param {String} action 格式為: {[輸入bed_id當Key值]: {auto: ??, auto_lock: ??}}
         */
        ADD_BED_STATES: (state, action) => {
            try {
                if (action.payload &&
                    action.payload !== null) {
                    const key = Object.keys(action.payload)[0];
                    const value = Object.values(action.payload)[0];

                    state.bed_states[key] = value
                    localStorage.setItem("bed_states", JSON.stringify(state.bed_states));
                }
            } catch (e) { console.error(e); }
        },
        ADD_BED_STATES_ALL: (state, action) => {
            try {
                if (action.payload &&
                    action.payload !== null) {

                    const key = Object.keys(action.payload)[0];
                    const value = Object.values(action.payload)[0];
                    state.bed_states_all[key] = value;
                    localStorage.setItem("bed_states_all", JSON.stringify(state.bed_states_all));
                }
            } catch (e) { console.error(e); }
        },
    }
})

export const {
    SET_DATA,
    GET_RESIDENT_ID_DATA,
    ADD_RR,
    ADD_BED_STATES,
    ADD_BED_STATES_ALL,
    ADD_BTN_STATUS,
} = bedInfosSlice.actions

export default bedInfosSlice.reducer